import React from "react";

interface ToggleSwitchProps {
  enabled: boolean;
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({ enabled, setEnabled }) => {
  return (
    <button
      onClick={() => setEnabled(!enabled)}
      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors duration-300 border border-[#C72BA4]
        ${enabled ? "bg-[#EA33C0]" : "bg-white/65"}`}
    >
      <span
        className={`inline-block h-4 w-4 transform rounded-full transition-transform duration-300
          ${enabled ? "translate-x-6 bg-white" : "translate-x-1 bg-[#EA33C0]"}`}
      />
    </button>
  );
};

export default ToggleSwitch;
